import { axiosInstance } from "./axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { IOffice, IOfficeSaveRequest } from "dto/Office/IOffice";

// Dane urzędu (Ustawienia → Urząd): nazwa, adres, NIP, REGON i herb bieżącej firmy. Z tych danych korzystają maile EBI
// (herb, nazwa i adres urzędu zamiast marki platformy) i CRU (NIP, REGON jednostki).

const queryKeys = {
  getOffice: "officeService.getOffice",
  getEmblem: "officeService.getEmblem",
};

const getOffice = (): Promise<{ data: IOffice }> => axiosInstance.get("office");

const useGetOffice = (enabled: boolean = true) =>
  useCustomQuery(queryKeys.getOffice, () => getOffice(), { enabled, retry: false });

const saveOffice = (payload: IOfficeSaveRequest): Promise<{ data: IOffice }> =>
  axiosInstance.post("office", payload);

const useSaveOffice = () => useCustomMutation(saveOffice);

/** Herb jako Blob (404 bez herbu); `version` w adresie omija pamięć podręczną przeglądarki po zmianie pliku. */
const getEmblem = (version?: string | null): Promise<{ data: Blob }> =>
  axiosInstance.get("office/emblem", { responseType: "blob", params: { v: version ?? "" } });

const useGetEmblem = (version?: string | null, enabled: boolean = true) =>
  useCustomQuery([queryKeys.getEmblem, version ?? ""], () => getEmblem(version), {
    enabled,
    retry: false,
  });

const uploadEmblem = (file: File): Promise<{ data: IOffice }> => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post("office/emblem", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const useUploadEmblem = () => useCustomMutation(uploadEmblem);

const removeEmblem = (): Promise<{ data: IOffice }> => axiosInstance.delete("office/emblem");

const useRemoveEmblem = () => useCustomMutation(removeEmblem);

export default {
  queryKeys,
  getOffice,
  useGetOffice,
  saveOffice,
  useSaveOffice,
  getEmblem,
  useGetEmblem,
  uploadEmblem,
  useUploadEmblem,
  removeEmblem,
  useRemoveEmblem,
};
